import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NoPredictiveintentPlanComponent } from './no-predictiveintent-plan.component';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule
    ],
    declarations: [NoPredictiveintentPlanComponent],
    exports: [NoPredictiveintentPlanComponent]
})
export class NoPredictiveintentPlanModule {}
